export type UserBonusInfoREST = {
	bonusHistoryExists: boolean;
	bonusStatus: BonusStatusEnum;
	bonusType: BonusTypeEnum;
	couponBonus: BonusInfoREST;
	depositBonus: BonusInfoREST;
	isCouponBonusAvailable: boolean;
	isDepositBonusAvailable: boolean;
	isRetailBonus: boolean;
	isUserValid: boolean;
	isVoucherBonusAvailable: boolean;
	lastPlayerBonusId: string;
	rolloverInfo: BonusRolloverInfoREST;
	shopName: string;
	totalPlayerBonuses: number;
	voucherBonus: BonusInfoREST;
};

export type BonusInfoREST = {
	activationTime: string;
	availabilityStatus: BonusAvailabilityStatus;
	bonusAmount: number;
	bonusDepositDetails: BonusDepositDetails;
	bonusId: string;
	bonusPercentage: number;
	bonusType: BonusTypeREST;
	currencyDisplayCode: string;
	depositAmount: number;
	maxBonusAmount: number;
	minQuote: number;
	minRolloverCoefficient: number;
	paymentTransactionData: UserPaymentTransactionREST;
	requiredRollover: number;
	shopName: string;
	transationData: UserTransactionREST;
	userId: string;
};

export type BonusRolloverInfoREST = {
	activationTime: string;
	bonusAmount: number;
	currencyDisplayCode: string;
	currentRollover: number;
	currentRolloverPercentage: number;
	depositAmount: number;
	requiredRollover: number;
	rolloverRemainder: number;
	rolloverRemainderPercentage: number;
};

export type BonusVoucherDetailsREST = {
	userBettingAccountTypeId: string;
	webBonusCode: string;
};

export type DepositBonusInfoREST = {
	bonusInfo: BonusInfoREST;
	isAccountVerificationRequired: boolean;
	isBonusAcceptedByUser: boolean;
	isDepositBonusAvailable: boolean;
	IsUserQualifiedForDepositBonus: boolean;
	IsVoucherAssignedToPlayer: boolean;
	status: BonusStatusEnum;
	voucherCode: string;
	errorCode?: number;
};

type UserTransactionREST = {
	amount: number;
	currency: CurrencyREST;
	id: string;
	numbericalId: string;
	transactionDate: string;
	userId: string;
};

type UserPaymentTransactionREST = {
	amount: number;
	ccExpiryDate: string;
	ccMaskedPan: string;
	currency: CurrencyREST;
	endDate: string;
	numbericalId: string;
	paymentMethod: PaymentMethodREST;
	startDate: string;
	transactionStatus: TransactionStatusREST;
	userId: string;
};

type TransactionStatusREST = {
	abrv: string;
	name: string;
};

type PaymentMethodREST = {
	abrv: string;
	code: string;
	displayName: string;
	name: string;
};

type CurrencyREST = {
	displayCode: string;
};

type BonusTypeREST = {
	abrv: string;
	isActive: boolean;
	name: string;
	sortOrder: number;
};

type BonusDepositDetails = {
	amount: number;
	agencyIdentifier: string;
	depositTransactionId: string;
};

export enum BonusStatusEnum {
	None = 0,
	CanGetBonus = 1,
	InvalidCode = 2,
	UsedBonus = 3,
	NotOnlineUser = 4,
	ActiveBonus = 5,
	NotVerified = 6,
	ActiveRelatedUserBonus = 7,
	UserAccountDisabled = 10,
	UserAccountDeactivationGracePeriodExpired = 11,
	MaxUsageAmountExceeded = 401203,
}

export enum BonusTypeEnum {
	Undefined = 0,
	Deposit = 1,
	Voucher = 2,
	Coupon = 3,
}

export enum BonusTabs {
	Bonus = 0,
	History = 1,
}

enum BonusAvailabilityStatus {
	Unavailable = 0,
	Available = 1,
}
